module.exports = __webpack_public_path__ + "static/q15_x-aa027e28e6000097df196fe7b050fe66.png";